import React from 'react';

const AboutContent = () => {
    return (
        <div className="about-section__text">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad asperiores cum cupiditate, eius
                excepturi
                fugiat inventore labore neque nesciunt nulla placeat, quia saepe, temporibus. Asperiores illo
                impedit
                itaque laborum nisi.</p>
        </div>
    );
};

export default AboutContent;
